const outsourcingModelMappingsModel = vm => ({
  title: vm.$gettext('Outsourcing Model Mappings'),
  endpoint: 'outsourcing-model-mappings',
  allowNew: true,
  allowDelete: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'platform_id',
      label: vm.$gettext('Platform'),
      type: 'select',
      options: 'platforms3p',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      sortable: true,
      required: true,
      description: vm.$gettext('To which platform the mapping is for'),
      default: null
    },
    {
      key: 'model_type',
      label: vm.$gettext('Model Type'),
      type: 'select',
      options: 'outsourcingModelMappings',
      withSelect: true,
      showRaw: true,
      sortable: true,
      required: true,
      description: vm.$gettext('The model type this map is for'),
      default: null
    },
    {
      key: 'model_id',
      label: vm.$gettext('Model ID'),
      type: 'text',
      required: true,
      description: vm.$gettext('The ID in our System')
    },
    {
      key: 'target_model_id',
      label: vm.$gettext('Target Model ID'),
      type: 'text',
      editable: true,
      required: true,
      description: vm.$gettext('The ID in the provider System')
    }
  ],
  filters: ['id', 'platform_id', 'model_type']
})

export default outsourcingModelMappingsModel
